import { reducer, rootSaga } from './_redux';

const loadInterface = () => import('./Interface');

export { loadInterface, reducer, rootSaga };
